export function isRouteMapSteady(routeMap) {
  return Object.values(routeMap).every(function (route) {
    return route.isSteady;
  });
}